import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { CampaignContent } from './campaign-content';
import { useSession } from '../../../../../infra/session';
import { useNavigate, useRouteParams } from '../../../../../infra/routing';
import { goToPreviousStep } from './go-to-previous-step';
import { goToNextStep } from './go-to-next-step';
import { validateStep } from './validate-step';
import { useApiMutation } from '../../../../../infra/api';
import { endpoints } from '../../../network';
import { useCampaignDetails, useDeliveryChannel } from '../../hooks';
import { EngageTracker, ENGAGE_CONTENT_PREVIEW_CHANNEL_SWITCHED } from '../../../tracking';
export var CampaignContentContainer = function () {
    var store = useStore();
    var navigate = useNavigate();
    var session = useSession().data;
    var campaignId = useRouteParams().campaignId;
    var _a = useDeliveryChannel(), availableDeliveryChannelsOptions = _a.availableDeliveryChannelsOptions, selectedDeliveryChannel = _a.selectedDeliveryChannel, setSelectedDeliveryChannel = _a.setSelectedDeliveryChannel;
    var campaign = useCampaignDetails(campaignId).campaign;
    var updateCampaignMutation = useApiMutation({ endpoint: endpoints.updateCampaignMutation });
    var handlePreviousStep = function () {
        goToPreviousStep({ store: store, navigate: navigate, session: session, campaignId: campaignId });
    };
    var handleNextStep = function () {
        var isValid = validateStep({ store: store });
        if (isValid) {
            goToNextStep({ store: store, navigate: navigate, session: session, campaignId: campaignId, updateCampaignMutation: updateCampaignMutation, campaign: campaign });
        }
    };
    var handleSelectDeliveryChannel = function (deliveryChannel) {
        var previousChannel = selectedDeliveryChannel;
        setSelectedDeliveryChannel(deliveryChannel);
        EngageTracker.getInstance().track(ENGAGE_CONTENT_PREVIEW_CHANNEL_SWITCHED, {
            fromChannel: previousChannel,
            toChannel: deliveryChannel,
            step: 'content',
            campaignId: campaignId,
        });
    };
    return (_jsx(CampaignContent, { onPreviousStep: handlePreviousStep, onNextStep: handleNextStep, availableDeliveryChannelsOptions: availableDeliveryChannelsOptions, selectedDeliveryChannel: selectedDeliveryChannel, onSelectDeliveryChannel: handleSelectDeliveryChannel, displayDeliveryChannelSwitch: availableDeliveryChannelsOptions.length > 1 }));
};
